import {
    ActionType,
    getListAction,
    getInfoAction,
    lookupAction,
    searchAction,
    openDialogAction,
    closeDialogAction,
    setKeywordAction,
    clearKeywordAction,
    initExtractedDiseasesAction
} from "./actions";
import { createSlice } from "@reduxjs/toolkit";
import { DiseaseKnowledgeDialogMode } from "./DiseaseKnowledgeDialogMode";
import { GetJson, GetListJson, LookupJson, SearchJson } from "./api";

export type DiseaseKnowledgeState = Readonly<{
    // 詳細
    diseases: { [key: string]: GetJson },
    // 一覧
    diseaseCategories: GetListJson | null,
    // 参照
    extractedDiseases: { [key: string]: LookupJson },
    // キーワード検索
    searchedDiseases: SearchJson | null,
    dialogMode: DiseaseKnowledgeDialogMode | null,
    keyword: string,
    processing: number,
    dialogProcessing: number
}>;

const initialState: DiseaseKnowledgeState = {
    diseases: {},
    diseaseCategories: null,
    extractedDiseases: {},
    searchedDiseases: null,
    dialogMode: null,
    keyword: "",
    processing: 0,
    dialogProcessing: 0
};

const slice = createSlice({
    name: ActionType.base,
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getListAction.pending,
                (state) => {
                    state.diseaseCategories = null;
                    state.processing += 1;
                }
            )
            .addCase(
                getListAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    state.diseaseCategories = payload;
                    state.processing -= 1;
                }
            )
            .addCase(
                getListAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                getInfoAction.pending,
                (state) => {
                    state.diseases = {};
                    state.processing += 1;
                }
            )
            .addCase(
                getInfoAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    state.diseases = {
                        [payload.disease.id]: payload
                    };
                    state.processing -= 1;
                }
            )
            .addCase(
                getInfoAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                lookupAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                lookupAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    state.extractedDiseases = {
                        diseases: payload
                    };
                    state.processing -= 1;
                }
            )
            .addCase(
                lookupAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                searchAction.pending,
                (state) => {
                    state.searchedDiseases = null;
                    state.processing += 1;
                }
            )
            .addCase(
                searchAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    state.searchedDiseases = payload;
                    state.processing -= 1;
                }
            )
            .addCase(
                searchAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                openDialogAction.pending,
                (state) => {
                    state.dialogProcessing += 1;
                }
            )
            .addCase(
                openDialogAction.fulfilled,
                (state, action) => {
                    state.dialogMode = action.payload;
                    state.dialogProcessing -= 1;
                }
            )
            .addCase(
                openDialogAction.rejected,
                (state) => {
                    state.dialogProcessing -= 1;
                }
            )
            .addCase(
                closeDialogAction,
                (state) => {
                    state.dialogMode = null;
                    state.dialogProcessing -= 1;
                }
            )
            .addCase(
                setKeywordAction.pending,
                () => {}
            )
            .addCase(
                setKeywordAction.fulfilled,
                (state, action) => {
                    state.keyword = action.payload;
                    state.dialogMode = "searchResult";
                }
            )
            .addCase(
                setKeywordAction.rejected,
                () => {}
            )
            .addCase(
                clearKeywordAction,
                (state) => {
                    state.keyword = "";
                    state.searchedDiseases = null;
                    state.dialogMode = "list";
                }
            )
            .addCase(
                initExtractedDiseasesAction,
                (state) => {
                    state.extractedDiseases = {};
                }
            )
        ;
    }
});

export const diseaseKnowledgeReducer = slice.reducer;